module.exports = __webpack_public_path__ + "static/media/astronaut-flag.9560e44c.svg";